
import React from "react";

export default function TableRowsNode({
  rows = [],
  row = "row",
  renderNode,
  children = [],
  context = {},
}: any) {
  return (
    <>
      {rows.map((value: any, index: number) => {
        const childContext = {
          ...context,
          [row]: value,
          index,
        };

        return (
          <React.Fragment key={index}>
            {children.map((child: any, i: number) =>
              renderNode(child, i, childContext)
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}
